import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { MessagecenterReadPage } from '../messagecenter-read/messagecenter-read';

import * as moment from 'moment';
import 'moment/locale/de';

import { UserProvider } from '../../providers/user';
import {TeamappProvider} from "../../providers/teamapp";

/**
 * Generated class for the MessagecenterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-messagecenter',
  templateUrl: 'messagecenter.html',
})
export class MessagecenterPage {
  messages: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {
    this.loadMessages();
  }

  loadMessages() {
      this.teamappProvider.http_request('action=get_messages', 'messages', false, true).then(data => {
          let messageData: any = data;
          if(!messageData.error) {
              this.messages = messageData;
          }
      });
  }

  loadMessage(group: any) {

    this.teamappProvider.http_request('action=reset_counter&group='+group.category_id, 'messages', false, true).then(data => {

        let messageData: any = data;
        console.log(messageData);
        if(!messageData.error) {
            group.unread_count = 0;
            this.userProvider.setUserMessageCount(0);
            this.navCtrl.push(MessagecenterReadPage, {messages: group.messages});
        }

    });

  }

  formatListDate(date: any) {
    return moment(date).format('D. MMM');
  }

}



// WEBPACK FOOTER //
// ./src/pages/messagecenter/messagecenter.ts